import { render } from "./Grammar.vue?vue&type=template&id=b423d83e&scoped=true"
import script from "./Grammar.vue?vue&type=script&lang=js"
export * from "./Grammar.vue?vue&type=script&lang=js"

import "./Grammar.vue?vue&type=style&index=0&id=b423d83e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b423d83e"]])

export default __exports__